import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import SportsTeamPage from './pages/SportsTeamPage';
import BasketballPage from './pages/BasketballPage';
import FantasyFootballPage from './pages/FantasyFootballPage';
import SuperheroPage from './pages/SuperheroPage';
import BarPage from './pages/BarPage';
import AcronymPage from './pages/AcronymPage';
import BookPage from './pages/BookPage';
import HTMLGeneratorPage from './pages/HTMLGeneratorPage';
import YouTubeTagPage from './pages/YouTubeTagPage';
import MetaPage from './pages/MetaPage';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="flex flex-col min-h-screen">
          <Header />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/sports" element={<SportsTeamPage />} />
              <Route path="/basketball" element={<BasketballPage />} />
              <Route path="/fantasy-football" element={<FantasyFootballPage />} />
              <Route path="/superhero" element={<SuperheroPage />} />
              <Route path="/bar" element={<BarPage />} />
              <Route path="/acronym" element={<AcronymPage />} />
              <Route path="/book" element={<BookPage />} />
              <Route path="/html" element={<HTMLGeneratorPage />} />
              <Route path="/youtube-tags" element={<YouTubeTagPage />} />
              <Route path="/meta" element={<MetaPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;